"use strict";var r=require("styled-components"),a=require("./color-cjs-BusDQ-L_.js"),e=require("./breakpoint-cjs-69WayOPp.js");const o=r.css`
  &:hover,
  &:focus,
  &:focus:hover {
    box-shadow: var(--shadow-boxShadow);
  }
`,t=r.css`
  &:hover,
  &:focus,
  &:focus:hover {
    box-shadow: var(--shadow-cardSlotHoverShadow);
  }
`,s=r.css`
  font-size: 14px;
  &:after {
    transition: all 0.6s ease;
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
          90deg,
          var(--border-color) 100%,
          transparent 100%
        )
        top left no-repeat,
      linear-gradient(
          90deg,
          transparent calc(var(--gap-size) / 2),
          var(--border-color) calc(var(--gap-size) / 2),
          var(--border-color) calc(var(--gap-size) / 2 + var(--dash-size)),
          transparent calc(var(--gap-size) / 2 + var(--dash-size))
        )
        top center repeat-x,
      linear-gradient(90deg, var(--border-color) 100%, transparent 100%) top
        right no-repeat,
      linear-gradient(0deg, var(--border-color) 100%, transparent 100%) top left
        no-repeat,
      linear-gradient(
          0deg,
          transparent calc(var(--gap-size) / 2),
          var(--border-color) calc(var(--gap-size) / 2),
          var(--border-color) calc(var(--gap-size) / 2 + var(--dash-size)),
          transparent calc(var(--gap-size) / 2 + var(--dash-size))
        )
        center left repeat-y,
      linear-gradient(0deg, var(--border-color) 100%, transparent 100%) bottom
        left no-repeat,
      linear-gradient(90deg, var(--border-color) 100%, transparent 100%) bottom
        left no-repeat,
      linear-gradient(
          90deg,
          transparent calc(var(--gap-size) / 2),
          var(--border-color) calc(var(--gap-size) / 2),
          var(--border-color) calc(var(--gap-size) / 2 + var(--dash-size)),
          transparent calc(var(--gap-size) / 2 + var(--dash-size))
        )
        bottom center repeat-x,
      linear-gradient(90deg, var(--border-color) 100%, transparent 100%) bottom
        right no-repeat,
      linear-gradient(0deg, var(--border-color) 100%, transparent 100%) top
        right no-repeat,
      linear-gradient(
          0deg,
          transparent calc(var(--gap-size) / 2),
          var(--border-color) calc(var(--gap-size) / 2),
          var(--border-color) calc(var(--gap-size) / 2 + var(--dash-size)),
          transparent calc(var(--gap-size) / 2 + var(--dash-size))
        )
        center right repeat-y,
      linear-gradient(0deg, var(--border-color) 100%, transparent 100%) bottom
        right no-repeat;
    background-size: var(--dash-size) var(--border-weight),
      calc(var(--dash-size) + var(--gap-size)) var(--border-weight),
      var(--dash-size) var(--border-weight),
      var(--border-weight) var(--dash-size),
      var(--border-weight) calc(var(--dash-size) + var(--gap-size)),
      var(--border-weight) var(--dash-size);
  }
`;var n=Object.freeze({__proto__:null,background:e.b,breakpoint:e.a,cardSlotHover:t,color:a.c,dashed:s,hover:o,shadow:e.s,spacing:e.c,typography:e.t});exports.c=t,exports.d=s,exports.h=o,exports.s=n;